import { application } from 'lib/pages-common'
import ParallaxStepsController from './parallax-steps-controller'

application.register('parallax-steps', ParallaxStepsController)
